export default function isTrimmedAndNonEmpty(value: string | null | undefined): boolean {
  const toCompareValue: string = value ?? "";
  return toCompareValue !== "" && toCompareValue[0] !== " " && toCompareValue.slice(-1) !== " ";
}
